<template>
  <el-form ref="baseForm" :rules="rules" :model="queryForm">
  <search-box @subSearch="onSubmit" :fromData="queryForm" style="margin:10px 0 10px 0">
    <el-form-item class="item" label="资源名称：" prop="resourceName">
      <el-input  v-model="queryForm.resourceName" clearable placeholder="请输入资源名称"></el-input>
    </el-form-item>
  </search-box>
  </el-form>
</template>

<script> 
import searchBox from 'components/common/search.vue';
export default{
  components:{
    searchBox
  },
  props:{
    initFormData:Object
  },
  data(){
    return{
      rules: {
        resourceName:[{message: "",trigger: "blur"}],
      },
      queryForm:this.initFormData||{}
    }
  },
  methods:{
    //搜索
    onSubmit(){
      let vm=this;
      vm.$emit('onSubmitSearch',vm.queryForm);
    }
  }
}
</script>

<style>
</style>
